export default {"src":"/_next/static/media/California.b58f59ce.svg","height":738,"width":800,"blurWidth":0,"blurHeight":0};